import React from 'react';

import { AtlassianLogo } from '@atlaskit/logo';

const LogoXlarge = (): React.JSX.Element => {
	return <AtlassianLogo size="xlarge" appearance="brand" />;
};

export default LogoXlarge;
